<footer class="compact-footer">
  <div class="compact-footer-content">
    <div class="compact-footer-main">
      <div class="compact-footer-brand">
        <img
          src="assets/icons/rocket-close-logo-white.svg"
          alt="Rocket Close"
          class="rocket-close-logo"
        />
        <div class="brand-info">
          <p class="brand-description">
            {{ 'footer.BRAND_DESCRIPTION' | translate }}
          </p>
          <p class="copyright">
            {{ 'footer.COPYRIGHT' | translate: { year: currentYear } }}
          </p>
        </div>
        <div class="rocket-close-product">
          <h3 class="product-title">
            {{ 'footer.ROCKET_CLOSE_TITLE' | translate }}
          </h3>
          <p class="product-description">
            {{ 'footer.ROCKET_CLOSE_DESCRIPTION' | translate }}
          </p>
        </div>
      </div>

      <div class="compact-footer-links">
        <div class="links-column">
          <h3 class="column-title">{{ 'footer.COMPANY_INFO_HEADING' | translate }}</h3>
          <ul class="links-list">
            @for (link of companyInfoLinks; track link.url) {
              <li>
                <a [href]="link.url" class="footer-link" target="_blank" rel="noopener noreferrer">
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">{{ 'footer.SITE_USE_HEADING' | translate }}</h3>
          <ul class="links-list">
            @for (link of siteUseLinks; track link.url) {
              <li>
                <a [href]="link.url" class="footer-link" target="_blank" rel="noopener noreferrer">
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">{{ 'footer.FOLLOW_US_HEADING' | translate }}</h3>
          <div class="social-links">
            @for (social of socialLinks; track social.name) {
              <a
                [href]="social.url"
                class="social-link"
                [attr.aria-label]="social.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img [src]="social.icon" [alt]="social.name" class="social-icon" />
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
